import React, { FC, useMemo } from "react";
import AnswerExplanationTopAppBar from "features/quiz/components/answerExplanationTopAppBar";
import { StudentAnswerType } from "models/studentAnswerType";
import AnswerExplanationBottomAppBar from "features/quiz/components/answerExplanationBottomAppBar";
import styles from "./_index.module.scss";
import { QuizType } from "../../../../models/quizType";
import useImages from "../../../../hooks/useImages";
import Spinner from "../../../../components/spinner";

export interface AnswerExplanationProps {
  currentQuizNumber: number;
  totalQuizCount: number;
  studentAnswer: StudentAnswerType;
  nextQuiz?: QuizType;
  onNavigationIconClick: () => void;
  onPauseClick: () => void;
  onNextClick: () => void;
}

const AnswerExplanation: FC<AnswerExplanationProps> = ({
  currentQuizNumber,
  totalQuizCount,
  studentAnswer,
  nextQuiz,
  onNavigationIconClick,
  onPauseClick,
  onNextClick,
}) => {
  const isCorrect = useMemo(() => studentAnswer.isCorrect, [studentAnswer]);

  const appBarTitle = useMemo(() => {
    const { answerText } = studentAnswer;

    return answerText === undefined
      ? "答えは下の解説を見てね！"
      : `答え : ${answerText}`;
  }, [studentAnswer]);

  const contentImageUrl = useMemo(
    () =>
      isCorrect
        ? studentAnswer.quiz.correctAnswerImageUrl
        : studentAnswer.quiz.wrongAnswerImageUrl,
    [isCorrect]
  );
  const { isLoading: isImageLoading } = useImages([contentImageUrl]);

  useImages(nextQuiz?.quizAssetUrls ?? []);

  return (
    <div className={styles.AnswerExplanation}>
      <AnswerExplanationTopAppBar
        title={appBarTitle}
        isCorrect={isCorrect}
        onNavigationIconClick={onNavigationIconClick}
      />

      {isImageLoading ? (
        <div className={styles["spinner-frame"]}>
          <Spinner />
        </div>
      ) : (
        <div className={styles.content}>
          <img src={contentImageUrl} alt="" />
        </div>
      )}

      <AnswerExplanationBottomAppBar
        currentQuizNumber={currentQuizNumber}
        totalQuizCount={totalQuizCount}
        onPauseClick={onPauseClick}
        onNextClick={onNextClick}
      />
    </div>
  );
};

export default AnswerExplanation;
